<template>
  <div class="passo" :class="{ 'passo--editando': editando }" @click="$emit('editar')">
    <div class="passo-header">
      <span class="passo-num">{{ index + 1 }}</span>
      <span class="passo-rotulo" :title="passo.seletor_alvo">
        {{ passo.rotulo || passo.seletor_alvo }}
      </span>
      <span v-if="!passo.seletor_estavel" class="passo-aviso" title="Seletor instável — use data-tour-id">
        ⚠
      </span>
      <div class="passo-acoes">
        <button type="button" :disabled="index === 0" @click.stop="$emit('mover', -1)">↑</button>
        <button type="button" :disabled="index === total - 1" @click.stop="$emit('mover', 1)">↓</button>
        <button type="button" @click.stop="$emit('remover')">✕</button>
      </div>
    </div>
    <div v-if="passo.rota_pattern && !editando" class="passo-rota" :title="passo.rota_pattern">
      Tela: {{ passo.rota_pattern }}
    </div>
    <div v-if="editando" class="passo-form" @click.stop>
      <input
        :value="passo.titulo"
        placeholder="Título do passo"
        class="passo-input"
        @input="$emit('atualizar', 'titulo', $event.target.value)"
      />
      <textarea
        :value="passo.descricao"
        placeholder="Descrição"
        rows="3"
        class="passo-input"
        @input="$emit('atualizar', 'descricao', $event.target.value)"
      ></textarea>
      <select
        :value="passo.posicionamento"
        class="passo-input"
        @change="$emit('atualizar', 'posicionamento', $event.target.value)"
      >
        <option v-for="p in ['bottom', 'top', 'left', 'right']" :key="p" :value="p">
          Tooltip: {{ p }}
        </option>
      </select>
      <label class="passo-label" :for="`rota-${passo.id}`">Tela do passo (rota)</label>
      <input
        :id="`rota-${passo.id}`"
        :value="passo.rota_pattern"
        placeholder="/ex: /empresas"
        class="passo-input"
        @input="$emit('atualizar', 'rota_pattern', $event.target.value)"
      />
      <label class="passo-check">
        <input
          type="checkbox"
          :checked="Boolean(passo.dispara_clique)"
          @change="$emit('atualizar', 'dispara_clique', $event.target.checked)"
        />
        <span>Disparar clique no elemento ao chegar neste passo</span>
      </label>
      <label class="passo-check">
        <input
          type="checkbox"
          :checked="Boolean(passo.dispara_hover)"
          @change="$emit('atualizar', 'dispara_hover', $event.target.checked)"
        />
        <span>Disparar hover no elemento ao chegar neste passo</span>
      </label>
    </div>
  </div>
</template>

<script setup>
defineProps({
  passo: { type: Object, required: true },
  index: { type: Number, required: true },
  total: { type: Number, required: true },
  editando: { type: Boolean, default: false }
})
defineEmits(['editar', 'atualizar', 'remover', 'mover'])
</script>

<style scoped>
.passo {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 6px;
  cursor: pointer;
}
.passo--editando {
  border-color: #5340b7;
  background: #f5f3ff;
}
.passo-header {
  display: flex;
  align-items: center;
  gap: 6px;
}
.passo-num {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5340b7;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.passo-rotulo {
  flex: 1;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.passo-aviso {
  color: #b58105;
  font-size: 13px;
  cursor: help;
}
.passo-acoes {
  display: flex;
  gap: 2px;
}
.passo-acoes button {
  background: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  font-size: 12px;
}
.passo-acoes button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.passo-rota {
  margin-top: 4px;
  font-size: 11px;
  color: var(--grafite);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.passo-form {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.passo-label {
  font-size: 11px;
  color: #555;
  margin-top: 2px;
}
.passo-input {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 12px;
  box-sizing: border-box;
  font-family: inherit;
}
.passo-check {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--neutral-gray-50);
  cursor: pointer;
  margin-top: 2px;
}
.passo-check input[type="checkbox"] {
  margin: 0;
}
</style>
